// projectsConfig.js - קונפיגורציה מרכזית לכל הפרויקטים

export const projectsConfig = [
  {
    id: 1,
    title: 'בית פרטי בשילת',
    subtitle: 'אורבניות בכפר',
    category: 'מודרני',
    folderName: 'בית פרטי בשילת',
    imageCount: 33,
    thumbnailIndex: 5
  },
  {
    id: 2,
    title: 'יוקרה במגדל',
    subtitle: 'דירת יוקרה אורבנית',
    category: 'מודרני',
    folderName: 'יוקרה במגדל - דירת יוקרה אורבנית',
    imageCount: 32,
    thumbnailIndex: 2
  },
  {
    id: 3,
    title: 'בית הפליסה',
    subtitle: 'בית פרטי ברמת חן',
    category: 'כפרי קלאסי',
    folderName: 'בית פרטי ברמת חן -בית הפליסה',
    imageCount: 49,
    thumbnailIndex: 4
  },
  {
    id: 4,
    title: 'פנטהאוז תל אביבי',
    subtitle: 'הגוש הגדול',
    category: 'מודרני',
    folderName: 'פנטהאוז תל אביבי - הגוש הגדול',
    imageCount: 29,
    thumbnailIndex: 8
  },
  {
    id: 5,
    title: 'בית מודרני ואלגנטי',
    subtitle: 'כפר בילו',
    category: 'מודרני',
    folderName: 'בית מודרני ואלגנטי בכפר בילו',
    imageCount: 39,
    thumbnailIndex: 37
  },
  {
    id: 6,
    title: 'בית פרטי כפרי',
    subtitle: 'קריית אונו',
    category: 'כפרי',
    folderName: 'בית פרטי כפרי בקרית אונו',
    imageCount: 37,
    thumbnailIndex: 6
  },
  {
    id: 7,
    title: 'דופלקס תל אביבי הפוך',
    subtitle: 'רמת אביב',
    category: 'מודרני',
    folderName: 'דופלקס תל אביבי הפוך',
    imageCount: 20,
    thumbnailIndex: 2
  },
  {
    id: 8,
    title: 'בית שמח מודרני',
    subtitle: 'מושב גיבתון',
    category: 'מודרני',
    folderName: 'בית שמח מודרני בכפר מושב גיבתון',
    imageCount: 34,
    thumbnailIndex: 13
  },
  {
    id: 9,
    title: 'דירת בוטיק',
    subtitle: 'הרצליה הילס',
    category: 'מודרני',
    folderName: 'דירת בוטיק - הרצליה הילס',
    imageCount: 21,
    thumbnailIndex: 6
  },
  {
    id: 10,
    title: 'פנטהאוז כפרי',
    subtitle: 'עיצוב פנים מקיף',
    category: 'כפרי',
    folderName: 'פנטהאוז כפרי',
    imageCount: 41,
    thumbnailIndex: 2
  },
  {
    id: 11,
    title: 'בית פרטי בשחור ולבן',
    subtitle: 'ניגודיות מושלמת',
    category: 'מודרני',
    folderName: 'בית פרטי בשחור ולבן',
    imageCount: 27,
    thumbnailIndex: 9
  },
  {
    id: 12,
    title: 'בית פרטי',
    subtitle: 'עיצוב מודרני',
    category: 'מודרני',
    folderName: 'בית פרטי (מודרני)',
    imageCount: 23,
    thumbnailIndex: 11
  },
  {
    id: 13,
    title: 'דירה תל אביבית בשחקים',
    subtitle: 'מגדלי דה וינצ\'י',
    category: 'מודרני',
    folderName: 'דירה תל אביבית בשחקים',
    imageCount: 21,
    thumbnailIndex: 9
  },
  {
    id: 14,
    title: 'דירת קבלן משודרגת',
    subtitle: 'עיצוב מודרני',
    category: 'מודרני',
    folderName: 'דירת קבלן משודרגת',
    imageCount: 17,
    thumbnailIndex: 10
  },
  {
    id: 15,
    title: 'בית כפרי מתועש',
    subtitle: 'כפרי קלאסי',
    category: 'כפרי קלאסי',
    folderName: 'בית כפרי מתועש',
    imageCount: 25,
    thumbnailIndex: 11
  },
  {
    id: 16,
    title: 'דופלקס בשחור ולבן',
    subtitle: 'עיצוב דרמטי',
    category: 'מודרני',
    folderName: 'דופלקס בשחור ולבן',
    imageCount: 24,
    thumbnailIndex: 13
  },
  {
    id: 17,
    title: 'חלום טוסקני',
    subtitle: 'דופלקס כפרי',
    category: 'כפרי',
    folderName: 'חלום טוסקני - דופלקס כפרי',
    imageCount: 35,
    thumbnailIndex: 16
  },
  {
    id: 18,
    title: 'בית פרטי וחם',
    subtitle: 'עיצוב מודרני',
    category: 'מודרני',
    folderName: 'בית פרטי וחם',
    imageCount: 17,
    thumbnailIndex: 9
  },
  {
    id: 19,
    title: 'Minimal House',
    subtitle: 'כפר אורנים',
    category: 'מודרני',
    folderName: 'בית פרטי כפר אורנים',
    imageCount: 16,
    thumbnailIndex: 4
  },
  {
    id: 20,
    title: 'בית בניחוח ספרדי',
    subtitle: 'Casa Azul',
    category: 'כפרי',
    folderName: 'בית בניחוח ספרדי',
    imageCount: 16,
    thumbnailIndex: 11
  }
];